import { Navigate, useParams } from 'react-router-dom';

export interface CompetitionRouteParams {
  competition: string;
  year: string;
}

/** Redirect old path-based check-in URLs to query-param routes. */
export default function CheckinCompetitionLegacyRedirect() {
  const { year, competition } = useParams<keyof CompetitionRouteParams>();

  const next = new URLSearchParams();
  if (year) next.set('year', year);
  if (competition) next.set('competition', competition);

  const qs = next.toString();
  return <Navigate to={qs ? `/dashboard/competition?${qs}` : '/dashboard/competition'} replace />;
}
